<div class="ard-overlay" (click)="onClose()">
  <div class="ard-card" role="dialog" aria-modal="true" aria-labelledby="ard-title"
    (click)="$event.stopPropagation()">

    @if (done()) {
      <!-- ── Sent state ── -->
      <div class="ard-sent">
        <span class="ard-sent__check"><i class="pi pi-check"></i></span>
        <h3 class="ard-sent__title">Request sent</h3>
        <p class="ard-sent__sub">The platform team has been notified and will follow up on your request.</p>
        <button type="button" class="ard-btn ard-btn--primary" (click)="onClose()">Done</button>
      </div>
    } @else {
      <!-- ── Form state ── -->
      <div class="ard-head">
        <span class="ard-head__icon"><i class="pi pi-lock"></i></span>
        <h3 class="ard-head__title" id="ard-title">Request access</h3>
        <button type="button" class="ard-x" (click)="onClose()" [disabled]="submitting()" aria-label="Close">
          <i class="pi pi-times"></i>
        </button>
      </div>

      <div class="ard-body">
        <div class="ard-field">
          <span class="ard-label">What do you need?</span>
          <div class="ard-ability">
            <span class="ard-ability__name">{{ term || abilityName }}</span>
            @if (system) { <span class="ard-ability__system">{{ system }}</span> }
          </div>
        </div>

        <div class="ard-field">
          <label class="ard-label" for="ard-usecase">
            What would you build with it? <span class="ard-optional">(optional)</span>
          </label>
          <textarea id="ard-usecase" class="ard-textarea" rows="4" maxlength="500"
            placeholder="A sentence or two about the agent or workflow you have in mind…"
            [ngModel]="useCase()" (ngModelChange)="useCase.set($event)"></textarea>
        </div>

        <div class="ard-field">
          <span class="ard-label" id="ard-when-label">When do you need it?</span>
          <div class="ard-chips" role="group" aria-labelledby="ard-when-label">
            @for (t of timeframes; track t.value) {
              <button type="button" class="ard-chip" [class.ard-chip--active]="timeframe() === t.value"
                (click)="timeframe.set(t.value)">{{ t.label }}</button>
            }
          </div>
        </div>

        <div class="ard-info">
          <i class="pi pi-info-circle"></i>
          <span>A request for access will be sent to the platform team, along with your name and use case.</span>
        </div>

        @if (error()) {
          <div class="ard-error" role="alert">Couldn’t send your request. Please try again.</div>
        }
      </div>

      <div class="ard-foot">
        <button type="button" class="ard-btn ard-btn--ghost" (click)="onClose()" [disabled]="submitting()">Cancel</button>
        <button type="button" class="ard-btn ard-btn--primary" (click)="send()" [disabled]="submitting()">
          {{ submitting() ? 'Sending…' : 'Send request' }}
        </button>
      </div>
    }
  </div>
</div>
